import Box from "@mui/material/Box";
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import theme from "../../../theme";


export const ContentOutBox = styled(Box)(props => {
  return {
    height: '76vh',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    transition: 'all .3s',
  }
})

export const ContentInBox = styled(Box)(props => {
  return {
    height: '100%',
    overflow: 'auto',
  }
})

export const FormTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey.w700
}))

export const ProductTitle = styled(Typography)(({ theme }) => ({
  margin: '2px 0',
  color: theme.palette.grey.w400
}))
